import { Validation } from './Validation';
import { MembershipType } from "./MembershipType";
import { MemberStatus } from "./MemberStatus";
import CustomerJson, { validateMemberChildCustomerJson, validateMemberCustomerJson, validateMemberCustomerJsonForm, validateMemberCustomerJsonAddNew } from "./CustomerJson";
import { MembershipRenewInterval } from "./MembershipRenewInterval";
import SepaMandateJson, { validateSepaMandate, validateSepaMandateAddNew } from "./SepaMandateJson";
import MembershipTermJson, { validateMembershipTermJson, validateMembershipTermJsonArraySequential } from './MembershipTermJson';

export default interface MemberJson {
   ID: number | null;

   /**
    * Art der Mitgliedschaft.
    */
   membershipType: MembershipType;

   /**
    * Freitextfeld für Bemerkungen.
    */
   remarks: string;

   /**
    * Mitgliedschaft wurde gekündigt
    */
   state: MemberStatus;

   /**
    * Mitgliedschaftszeiträume
    */
   membershipTerms: MembershipTermJson[];

   /**
    * Eltern und Kinder.
    */
   customers: CustomerJson[];

   /**
    * Mitgliedschaftsbeitrag, Förderbeitrag, Versicherungsbeitrag in Eurocent für den nächsten Abrechnungszeitraum (also 6 Monate oder 12 Monate).
    */
   price: number | null;

   /**
    * Intervall der Beitragszahlung. E.g. der Zeitraum um den die Mitgliedschaft automatisch verlängert werden soll, wenn sie ausläuft.
    */
   renewInterval: MembershipRenewInterval;

   /**
    * SEPA-Lastschriftmandat für die Zahlung. Kann auch null sein, wenn eine Bar oder Rechnungszahlung gewünscht ist.
    */
   sepaMandate: SepaMandateJson | null;

   /**
    * Datum und Uhrzeit zu der das Mitglied angelegt wurde.
    */
   creationDateTime: string;

   /**
    * Falls ein MailingRecipient verlinkt ist: ID des Member:
    */
   //linkedMailingRecipientId: number | null;
}

export function validateMemberJsonForm(item: MemberJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateEquals("state", MemberStatus.requested)
      .validateString("remarks", 1000)
      .validateAllUsingFunction("customers", validateMemberCustomerJsonForm, 1)
      .validateDate("creationDateTime")
      .validateUsingFunction("sepaMandate", validateSepaMandateAddNew, true)
      .validateInteger("price", 0, null, true)
      .finish();
}

export function validateMemberJsonManagement(item: MemberJson) {
   return new Validation(item)
      .validateInteger("ID", 0)
      .validateUsingFunction("membershipTerms", validateMembershipTermJsonArraySequential)
      .validateString("remarks", 1000)
      .validateAllUsingFunction("customers", validateMemberCustomerJson, 1)
      .validateDate("creationDateTime")
      .validateUsingFunction("sepaMandate", validateSepaMandate, true)
      .validateInteger("price", 0, null)
      .finish();
}

export function validateMemberJsonManagementAdd(item: MemberJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateUsingFunction("membershipTerms", validateMembershipTermJsonArraySequential)
      .validateString("remarks", 1000)
      .validateAllUsingFunction("customers", validateMemberCustomerJsonAddNew, 1)
      .validateDate("creationDateTime")
      .validateUsingFunction("sepaMandate", validateSepaMandateAddNew, true)
      .validateInteger("price", 0, null)
      .finish();
}

export function validateMemberJsonChilds(item: CustomerJson[]) {
   return new Validation({ "childs": item })
      .validateAllUsingFunction("childs", validateMemberChildCustomerJson, 1)
      .finish();
}

export function getMemberRenewalMinDate(membershipPaymentDaysAhead: number): Date {
   var stopDate = new Date();
   stopDate.setDate(stopDate.getDate() + membershipPaymentDaysAhead);
   stopDate.setHours(0, 0, 0);
   return stopDate;
}